import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
import getConfigDetails from './services/config'

const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('92ae025debc64617a501d10b84a16d48').install()
root.render(
	<GoogleReCaptchaProvider reCaptchaKey={getConfigDetails.recaptchaSiteKey}>
		<React.StrictMode>
			<Provider store={configureStore()}>
				<App />
			</Provider>
		</React.StrictMode>
	</GoogleReCaptchaProvider>
)
reportWebVitals()
